import { SolicitudValidate } from './../entities/SolicitudValidate.entity';
import { UsuarioOnline } from './../entities/UsuarioOnline.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { Domiciliacion } from '../entities/domiciliacion.entity';
import { Contrato } from '../entities/contrato.entity';
import * as FileSaver from 'file-saver';
import { PageScrollConfig, PageScrollService, PageScrollInstance, PageScroll } from 'ngx-page-scroll';
import { Respuesta } from '../entities/respuesta.entity';
import { ValidationError, validate } from 'class-validator';

@Component({
  selector: 'app-domiciliacionFactura',
  templateUrl: './domiciliacionFactura.component.html'
})
export class DomiciliacionFacturaComponent implements OnInit {

  public nombreSolicitante: string;
  public identificacionsolicitante: string;
  public emailSolicitante: string;
  public telefonoSolicitante: string;
  public nombrePagador: string;
  public tipoIdentidadPagador: string;
  public identificacionPagador: string;
  public nacionalidadPagador: string;
  public paisPagador: string;
  public provinciaPagador: string;
  public poblacionPagador: string;
  public direccionPagador: string;
  public codigoPostalPagador: string;
  public bic: string;
  public iban: string;
  public resultado: Respuesta;

  public datosDomiciliacion: Domiciliacion;
  public usuario: UsuarioOnline;
  public contrato: Contrato;

  public nombrePagadorInputError: boolean;
  public tipoIdentidadPagadorInputError: boolean;
  public identificacionPagadorInputError: boolean;
  public nacionalidadPagadorInputError: boolean;
  public paisPagadorInputError: boolean;
  public provinciaPagadorInputError: boolean;
  public poblacionPagadorInputError: boolean;
  public direccionPagadorInputError: boolean;
  public codigoPostalPagadorInputError: boolean;
  public bicInputError: boolean;
  public ibanInputError: boolean;

  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public descargaMandato: boolean;
  public direccionSuministro: string;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    if (this.sessionService.isAuthenticated) {
      this.descargaMandato = false;
      this.clearInputErrors();
      this.nombreSolicitante = this.sessionService.nombre;
      this.identificacionsolicitante = this.sessionService.login;
      this.emailSolicitante = this.sessionService.email;
      this.telefonoSolicitante = this.sessionService.telefono;
      this.CargarDatosContrato(this.sessionService.contratoSelected);
    } else {
      this.router.navigate(['/']);
    }
  }

  public CargarDatosContrato(contrato: Contrato) {
    this.nombrePagador = contrato.PagadorNombre;
    this.tipoIdentidadPagador = contrato.PagadorTipoDoc;
    this.identificacionPagador = contrato.PagadorDocIden;
    this.nacionalidadPagador = contrato.PagadorNacionalidad;
    this.paisPagador = contrato.PagadorNacion;
    this.provinciaPagador = contrato.PagadorProvincia;
    this.poblacionPagador = contrato.PagadorPoblacion;
    this.direccionPagador = contrato.PagadorDireccion;
    this.codigoPostalPagador = contrato.PagadorCpostal;
    this.direccionSuministro = contrato.InmuebleBO.Direccion;
    this.bic = contrato.Bic;
    this.iban = contrato.Iban;
  }

  public enviar(): void {
    this.CargarDatosEnvio();
    this.clearInputErrors();
    validate(this.cargarDatosValidar(this.contrato)).then(resultadoUsuario => {
      if (resultadoUsuario.length > 0) {
        this.showErrors(resultadoUsuario);
      } else {
        if (document.getElementById('top') !== null)
          document.getElementById('top').scrollIntoView();
        this.userService.domiciliarFactura(this.sessionService.explotacion, this.datosDomiciliacion).subscribe(
          response => this.domicialiacionOnSuccess(response),
          response => this.domicialiacionOnError(response)
        );
      }
    });
  }

  public Descargar() {
    this.userService.descargarMandato(this.sessionService.explotacion, this.datosDomiciliacion).subscribe(
      response => this.mandatoOnSuccess(response),
      response => this.mandatoOnError(response)
    );
  }

  public CargarDatosEnvio() {
    this.datosDomiciliacion = new Domiciliacion();
    this.usuario = new UsuarioOnline();
    this.contrato = new Contrato();

    this.usuario.Nombre = this.nombreSolicitante;
    this.usuario.Login = this.identificacionsolicitante;
    this.usuario.EMail = this.emailSolicitante;
    this.usuario.Telefono1 = this.telefonoSolicitante;

    this.contrato = this.sessionService.contratoSelected;
    this.contrato.PagadorNombre = this.nombrePagador;
    this.contrato.PagadorTipoDoc = this.tipoIdentidadPagador;
    this.contrato.PagadorDocIden = this.identificacionPagador;
    this.contrato.PagadorNacionalidad = this.nacionalidadPagador;
    this.contrato.PagadorNacion = this.paisPagador;
    this.contrato.PagadorProvincia = this.provinciaPagador;
    this.contrato.PagadorPoblacion = this.poblacionPagador;
    this.contrato.PagadorDireccion = this.direccionPagador;
    this.contrato.PagadorCpostal = this.codigoPostalPagador;
    this.contrato.Bic = this.bic;
    if (this.iban) {
      this.contrato.Iban = this.iban.replace(new RegExp(' ', 'g'), '');
      this.iban = this.contrato.Iban;
    } else {
      this.contrato.Iban = this.iban;
    }
    this.datosDomiciliacion.TipoSolicitud = 'domicBanc';
    this.datosDomiciliacion.Poblacion = this.sessionService.explotacion;
    this.datosDomiciliacion.Contrato = this.contrato;
    this.datosDomiciliacion.UsuarioOnline = this.usuario;
  }

  public domicialiacionOnSuccess(response) {
    this.typeException = 0;
    this.messageCabecera = 'Descargue el mandato para su firma';
    if (this.sessionService.explotacion !== 'AVG') {
      this.messageComplet = 'La domiciliación se realizará en el momento de recibir el mandato descargado con su firma.';
    }
    this.descargaMandato = true;
    this.Descargar();
  }

  public domicialiacionOnError(response) {
    this.messageCabecera = 'Envio erroneo';
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.typeException = 1;
      this.messageComplet = 'El proceso no se ha realizado correctamente. Intentelo de nuevo en unos minutos';
    }
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.CargarDatosContrato(contratoSelect);
    this.clearInputErrors();
  }

  public mandatoOnSuccess(response) {
    const fichero: Blob = response;
    const filename = 'mandato.pdf';
    FileSaver.saveAs(fichero, filename);
    this.typeException = 0;
    this.messageCabecera = 'Su solicitud ha sido enviada';
    if (this.sessionService.explotacion === 'AVG') {
      this.messageComplet = 'La domiciliación se realizará una vez remitan un justificante de titularidad de la cuenta bancaria, '
        + 'junto con el mandato firmado a infoavg@sacyr.com y estos sean verificados.';
    } else {
      this.messageComplet = 'La domiciliación se realizará en el momento de recibir firmado el mandato, en la mayor brevedad posible.';
    }
  }

  public mandatoOnError(response) {
    this.messageCabecera = 'Envio erroneo';
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.typeException = 1;
      this.messageComplet = 'El mandato no se ha generado. Intentelo de nuevo en unos minutos';
    }
  }

  public showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'Nombre':
          this.nombrePagadorInputError = true;
          break;
        case 'TipoDoc':
          this.tipoIdentidadPagadorInputError = true;
          break;
        case 'DocIden':
          this.identificacionPagadorInputError = true;
          break;
        case 'Nacionalidad':
          this.nacionalidadPagadorInputError = true;
          break;
        case 'Nacion':
          this.paisPagadorInputError = true;
          break;
        case 'Provincia':
          this.provinciaPagadorInputError = true;
          break;
        case 'Poblacion':
          this.poblacionPagadorInputError = true;
          break;
        case 'Cpostal':
          this.codigoPostalPagadorInputError = true;
          break;
        case 'Direccion':
          this.direccionPagadorInputError = true;
          break;
        case 'Bic':
          this.bicInputError = true;
          break;
        case 'Iban':
          this.ibanInputError = true;
          break;
      }
    }
  }

  public clearInputErrors() {
    this.nombrePagadorInputError = false;
    this.tipoIdentidadPagadorInputError = false;
    this.identificacionPagadorInputError = false;
    this.nacionalidadPagadorInputError = false;
    this.paisPagadorInputError = false;
    this.provinciaPagadorInputError = false;
    this.poblacionPagadorInputError = false;
    this.direccionPagadorInputError = false;
    this.codigoPostalPagadorInputError = false;
    this.bicInputError = false;
    this.ibanInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public cargarDatosValidar(contrato: Contrato): SolicitudValidate {
    const datosValidar = new SolicitudValidate();
    datosValidar.Nombre = contrato.PagadorNombre;
    datosValidar.TipoDoc = contrato.PagadorTipoDoc;
    datosValidar.DocIden = contrato.PagadorDocIden;
    datosValidar.Nacionalidad = contrato.PagadorNacionalidad;
    datosValidar.Nacion = contrato.PagadorNacion;
    datosValidar.Provincia = contrato.PagadorProvincia;
    datosValidar.Poblacion = contrato.PagadorPoblacion;
    datosValidar.Direccion = contrato.PagadorDireccion;
    datosValidar.Cpostal = contrato.PagadorCpostal;
    datosValidar.Bic = contrato.Bic;
    datosValidar.Iban = contrato.Iban;
    return datosValidar;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/domiciliacionFactura.component.ts